<div class="not-found-container">
  <img class="illustration" src="assets/illu_404_grey.svg" alt="404 illustration" />
  <span class="description">Page non trouvée</span>
  @if (isAuthenticated$ | async) {
    <button class="logout-button" strocked color="primary" tiime-button (click)="logout()">
      Déconnexion
      <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-ic-logout"></mat-icon>
    </button>
  }
</div>
